import Info from 'components/shared/Info'
import styled from 'styled-components/macro'

export const InfoWrapper = styled(Info)`
    .icon-tooltip {
        margin-right: 14px;
    }
`
